import { render, staticRenderFns } from "./CameraModal.vue?vue&type=template&id=231fb215&"
import script from "./CameraModal.vue?vue&type=script&lang=js&"
export * from "./CameraModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CameraModal.vue"
export default component.exports